function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0editaricon{fill:#C1C8D9;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0editaricon",
  d: "M11.4,4.7v-1h2.7v1c0,0.5,0.4,0.9,0.9,0.9h0.2c0.5,0,0.9-0.4,0.9-0.9v-1H19v1c0,0.5,0.4,0.9,0.9,0.9h0.2 c0.5,0,0.9-0.4,0.9-0.9v-1h0.6l1.8,1.8v2.8h1.9V4.7l-2.9-2.8h-1.3v-1c0-0.5-0.4-0.9-0.9-0.9H20C19.4,0,19,0.4,19,0.9v1h-2.7v-1 c0-0.5-0.4-0.9-0.9-0.9h-0.2c-0.5,0-0.9,0.4-0.9,0.9v1h-2.7v-1C11.4,0.4,11,0,10.5,0h-0.2C9.7,0,9.3,0.4,9.3,0.9v1H6.6v-1 C6.6,0.4,6.1,0,5.6,0H5.4C4.9,0,4.4,0.4,4.4,0.9v1H0V30h8.3l0.5-1.9H1.9V3.8h2.6v1c0,0.5,0.4,0.9,0.9,0.9h0.2 c0.5,0,0.9-0.4,0.9-0.9v-1h2.7v1c0,0.5,0.4,0.9,0.9,0.9h0.2C11,5.7,11.4,5.2,11.4,4.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0editaricon",
  d: "M29.4,14.3l-3-3c-0.7-0.7-1.9-0.7-2.6,0c0,0,0,0,0,0l0,0l-11,10.9l-0.2,0.2l-1.9,7.6l7.6-1.9l0.7-0.7l0,0 l10.5-10.5h0c0,0,0,0,0,0C30.2,16.2,30.2,15,29.4,14.3z M13.4,23.1l4.1,4.1l-3.9,1L12.4,27L13.4,23.1z M18.3,24.7L16,22.4l7.9-7.8 l2.3,2.3L18.3,24.7z"
}));

var SvgEditardisabled = function SvgEditardisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditardisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editardisabled.9747cc42.svg";
export { ForwardRef as ReactComponent };